module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_3_5.68119cff.png";